import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

/// comments section
export const GetComment = createAsyncThunk("GetComment", async ({ id, page }) => {
    const response = await axiosInstance.get(`/post/${id}/comments/?page=${page}`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});
export const CreateComment = createAsyncThunk("CreateComment", async (data) => {
    const response = await axiosInstance.post(`post/comment/${data.key}/`, {
        post_comment_box: data.body,
    });
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});
export const DeleteComment = createAsyncThunk("DeleteComment", async (data) => {
    const response = await axiosInstance.delete(`post/delete_comment/${data}/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});
export const UpdateComment = createAsyncThunk("UpdateComment", async (data) => {
    const response = await axiosInstance.patch(
        `/post/update_comment/${data.key}/`,
        {
            post_comment_box: data.body,
        }
    );
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});
export const CommentDelete = createAsyncThunk("CommentDelete", async (data) => {
    try {
        const response = await axiosInstance.delete(`/post/comment/${data}/delete_reply/`);
        if (response.status === 204) {
            // Return the data (comment ID) explicitly since the response body is empty
            return data;
        }
        return response.data;
    } catch (error) {
        return error;
    }
});
export const CommentLike = createAsyncThunk("CommentLike", async (id) => {
    const response = await axiosInstance.post(`/group/comment/${id}/like/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const likeDislikeComment = createAsyncThunk(
    "likeDislikeComment",
    async ({ commentId }, { rejectWithValue }) => {
        const response = await axiosInstance.post(
            `/post/like_comment/${commentId}/`
        );
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
///reply section
export const getCommentReply = createAsyncThunk(
    "getCommentReply",
    async ({ commentId }, { rejectWithValue }) => {
        const response = await axiosInstance.get(
            `/post/comments/${commentId}/replies/`
        );
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const ReplayComment = createAsyncThunk("ReplayComment", async (data) => {
    const response = await axiosInstance.post(
        `post/comment/${data.key}/replies/`,
        {
            post_comment_box: data.body,
        }
    );
    try {
        const result = response.data;
        return { result, commentId: data.key };
    } catch (error) {
        return error;
    }
});
export const updateCommentReply = createAsyncThunk(
    "updateCommentReply",
    async ({ replyId, value }, { rejectWithValue }) => {
        const response = await axiosInstance.patch(
            `/post/comment/${replyId}/reply/`,
            { post_comment_box: value }
        );
        try {
            const result = response.data;
            return { result, replyId };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const replyNestedReply = createAsyncThunk(
    "replyNestedReply",
    async (data, { rejectWithValue }) => {
        const response = await axiosInstance.post(
            `/post/reply/${data.key}/reply/`,
            { post_comment_box: data.body }
        );
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const deleteNestedReply = createAsyncThunk(
    "deleteNestedReply",
    async ({ nestedReplyId }, { rejectWithValue }) => {
        const response = await axiosInstance.delete(
            `/post/nested_reply/${nestedReplyId}/delete/`
        );
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const updateNestedReply = createAsyncThunk(
    "updateNestedReply",
    async ({ nestedReplyId, value }, { rejectWithValue }) => {
        const response = await axiosInstance.patch(
            `/post/nested_reply/${nestedReplyId}/update/`,
            { post_comment_box: value }
        );
        try {
            const result = response.data;
            return { result, nestedReplyId };

        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const likeDislikeCommentReply = createAsyncThunk(
    "likeDislikeCommentReply",
    async ({ replyId }, { rejectWithValue }) => {
        const response = await axiosInstance.post(
            `/post/comment/like_reply/${replyId}/`
        );
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const commentReplyDelete = createAsyncThunk(
    "commentReplyDelete",
    async ({ replyId, commentId }, { rejectWithValue }) => {
        const response = await axiosInstance.delete(
            `/post/comment/${replyId}/delete_reply/`
        );
        try {
            const result = response.data;
            return { result, commentId };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const commentReport = createAsyncThunk(
    "commentReport",
    async ({ commentId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/post/report_comment/${commentId}/`,
                data
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error);
        }
    }
);
export const commentsSlice = createSlice({
    name: "commentsSlice",
    initialState: {
        postCommants: [],
        commentReplies: [],
        loading: false,
        createCommentLoading: false,
        replyLoading: false,
        error: null,
    },
    extraReducers: (builder) => {
        /* HomeVideoFootage comments */
        builder.addCase(GetComment.pending, (state) => {
            state.loading = true;
            state.postCommants = [];
        });
        builder.addCase(GetComment.fulfilled, (state, action) => {
            state.postCommants = action.payload.results.comments
            state.loading = false;
        });
        builder.addCase(GetComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


        // create comment
        builder.addCase(CreateComment.pending, (state) => {
            state.createCommentLoading = true;
        });
        builder.addCase(CreateComment.fulfilled, (state, action) => {
            state.postCommants = [action.payload, ...state.postCommants];
            state.createCommentLoading = false;
        }
        );
        builder.addCase(CreateComment.rejected, (state, action) => {
            state.createCommentLoading = false;
            state.error = action.payload;
        });

        // get comment reply by comment id

        builder.addCase(getCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(getCommentReply.fulfilled, (state, action) => {
            state.commentReplies = action.payload.replies;
            state.replyLoading = false;
        });
        builder.addCase(getCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        /* ReplayComment comments */
        builder.addCase(ReplayComment.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(ReplayComment.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.postCommants = state.postCommants.map((comment) => {
                if (comment.id === action.payload.commentId) {
                    return {
                        ...comment,
                        reply_count: comment.reply_count + 1,

                    };
                }
                return comment;
            });
        });
        builder.addCase(ReplayComment.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        builder.addCase(updateCommentReply.pending, (state) => {
            state.replyLoading = true;
        }
        );
        builder.addCase(updateCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.commentReplies = state.commentReplies.map((reply) => {
                if (reply.id === action.payload.replyId) {
                    return action.payload.result;
                }
                return reply;
            }
            );
        });
        builder.addCase(updateCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        }
        );

        /* CommentDelete comments */
        builder.addCase(CommentDelete.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(CommentDelete.fulfilled, (state, action) => {
            // state.postCommants = action.payload;
            state.loading = false;

            state.postCommants = state.postCommants.filter(
                (comment) => comment.id !== action.payload.data
            );

        });
        builder.addCase(CommentDelete.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        /* commentReplyDelete comments */
        builder.addCase(commentReplyDelete.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(commentReplyDelete.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.postCommants = state.postCommants.map((comment) => {
                if (comment.id === action.payload.commentId) {
                    return {
                        ...comment,
                        reply_count: comment.reply_count - 1,

                    };
                }
                return comment;
            });

        });
        builder.addCase(commentReplyDelete.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        builder.addCase(updateNestedReply.pending, (state) => {
            state.loading = true;
        }
        );
        builder.addCase(updateNestedReply.fulfilled, (state, action) => {
            state.loading = false;
            state.commentReplies = state.commentReplies.map((reply) => {
                reply.nested_replies.map((nestedReply) => {
                    if (nestedReply.id === action.payload.nestedReplyId) {
                        return action.payload.result;
                    }
                    return nestedReply;
                });
            }
            );
        }
        );
        builder.addCase(updateNestedReply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
        );
    },
});

export default commentsSlice.reducer;
